import {
  ADD_REVIEW_RESPONSE,
  REVIEW_CHANGE,
  UPDATE_REVIEW_RESPONSE,
  UPDATE_REVIEW_FOR_COOKBOOK_RESPONSE,
} from 'actions/reviews';
import { GET_HOME_REVIEWABLE_MEALS_RESPONSE } from 'actions/v3/reviewableMeals';
import {
  SHOW_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL,
  HIDE_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL,
  HIDE_BEHAVIORAL_DISCOUNT_SHOPPABLE_CONFIRMATION_MODAL,
} from 'actions/v3/shoppablePages';
import { GET_USER_BEHAVIORAL_DISCOUNT_CONFIRMATION_RESPONSE } from 'lib/constants/v3Actions';
import { transformReviewableMealReviews } from 'services/RequestService/helpers';

const initialState = {
  currentMenu: {},
  isLoading: false,
  previousBaskets: [],
  previousMenu: {},
  reviewableMeals: [],
  sections: [],
  promotionMealDetails: {
    mealId: null,
    menuSlug: null,
    shouldDisplayConfirmationModal: false,
    actionType: null,
  },
  promotionShoppable: {
    menuSlug: null,
    mealIds: [],
    basketWasInitiallySkipped: false,
    shouldDisplayConfirmationModal: false,
  },
  behavioralDiscountShoppable: {
    menuSlug: null,
    shouldDisplayConfirmationModal: false,
    confirmationModal: {
      isLoading: true,
      deliveryDate: null,
      discountAmountCents: 0,
      discountTriggered: false,
      mealDiscounts: [],
      mealSelections: [],
      promotionText: null,
      subtitle: null,
      title: null,
    },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HOME_REVIEWABLE_MEALS_RESPONSE:
      return {
        ...state,
        reviewableMeals: action.response.reviewableMeals || [],
      };
    case ADD_REVIEW_RESPONSE:
    case UPDATE_REVIEW_RESPONSE:
    case UPDATE_REVIEW_FOR_COOKBOOK_RESPONSE:
      return transformReviewableMealReviews(state, action.response);
    case REVIEW_CHANGE:
      return {
        ...state,
        reviewableMeals: state.reviewableMeals.map(reviewableMeal =>
          reviewableMeal.mealId === action.mealId
            ? {
                ...reviewableMeal,
                review: {
                  ...reviewableMeal.review,
                  pendingChanges: { recipeRating: action.review.recipeRating },
                },
              }
            : reviewableMeal
        ),
      };
    case SHOW_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL:
      return {
        ...state,
        promotionShoppable: {
          menuSlug: action.menuSlug,
          mealIds: action.mealIds,
          basketWasInitiallySkipped: action.basketWasInitiallySkipped,
          shouldDisplayConfirmationModal: true,
        },
      };
    case HIDE_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL:
      return {
        ...state,
        promotionShoppable: initialState.promotionShoppable,
      };
    case GET_USER_BEHAVIORAL_DISCOUNT_CONFIRMATION_RESPONSE:
      return {
        ...state,
        behavioralDiscountShoppable: {
          ...state.behavioralDiscountShoppable,
          menuSlug: action.params.menuSlug,
          shouldDisplayConfirmationModal: true,
          confirmationModal: {
            ...state.behavioralDiscountShoppable.confirmationModal,
            ...action.response.confirmation,
            isLoading: false,
          },
        },
      };
    case HIDE_BEHAVIORAL_DISCOUNT_SHOPPABLE_CONFIRMATION_MODAL:
      return {
        ...state,
        behavioralDiscountShoppable: initialState.behavioralDiscountShoppable,
      };
    default:
      return state;
  }
};

const selectHomepage = state => state.v3.homepage;
export const selectReviewableMeals = state => selectHomepage(state).reviewableMeals;
export const selectReviewableMeal = (state, mealId) =>
  selectReviewableMeals(state).find(meal => meal.mealId === mealId);
export const selectReviewableMealReview = (state, mealId) =>
  selectReviewableMeal(state, mealId)?.review;
export const selectPromotionShoppable = state => selectHomepage(state).promotionShoppable;
export const selectBehavioralDiscountShoppable = state =>
  selectHomepage(state).behavioralDiscountShoppable;
